__turbopack_context__.v({
  "container": "IconList-module__PrM4oW__container",
  "container__items": "IconList-module__PrM4oW__container__items",
  "container__items__3_col": "IconList-module__PrM4oW__container__items__3_col",
  "container__items__4_col": "IconList-module__PrM4oW__container__items__4_col",
  "container__items__item": "IconList-module__PrM4oW__container__items__item",
  "container__items__item__icon": "IconList-module__PrM4oW__container__items__item__icon",
  "container__items__item__icon__svg_container": "IconList-module__PrM4oW__container__items__item__icon__svg_container",
  "container__map": "IconList-module__PrM4oW__container__map",
  "container__ref": "IconList-module__PrM4oW__container__ref",
});
